export type PopoverState = {
    xPos: number
    yPos: number
    date: Date
    open: boolean
    scheduleId: number | null
    leaseAuditId: number | null
    eventId: number | null
}

export type ModalState = {
    mode: 'create' | 'edit' | null
    formData: ScheduleFormData
}

export type ScheduleFormData = {
    name: string
    description: string
    start_date: Date
    has_recurrence: boolean
    recurrence_pattern: string
    companies: number[]
    id?: number
}

export const recurrencePatterns = [
    { value: 'DAILY', label: 'Daily' },
    { value: 'WEEKLY', label: 'Weekly' },
    { value: 'BIWEEKLY', label: 'Biweekly' },
    { value: 'MONTHLY', label: 'Monthly' },
    { value: 'QUARTERLY', label: 'Quarterly' },
    { value: 'ANNUALLY', label: 'Annually' },
]
